import React from "react";
import styles from "./Upgrade.module.scss";
import classnames from "classnames";
import { Store } from "public-components/StoreProvider";
// import addpageView from "utils/analysis";
import multipleSiteEnum from "constants/multipleSiteEnum.js";
import axios from "axios";
import baseUrl from "constants/baseUrl";

let FTCommon, FTUserMessage;
if (typeof window !== `undefined`) {
  const common = require("fotor-common");
  FTCommon = common.FTCommon;
  FTUserMessage = common.FTUserMessage;
}

const Upgrade = ({ siteId }) => {
  const { state, dispatch } = React.useContext(Store);
  const [showAuthModal, setShowAuthModal] = React.useState(null);
  const { userInfo, isVip } = state;
  const checkIsVip = (type) => {
    axios.get(`${baseUrl}pay/service/en/payment/check/isvip`).then((res) => {
      dispatch({
        type: "UPDATE_IS_VIP",
        payload:
          res.status === 200 && res.data && res.data.data && res.data.data.vipStatus ? true : false
      });
      if (
        type === 1 &&
        res.status === 200 &&
        res.data &&
        res.data.data &&
        !res.data.data.vipStatus
      ) {
        showPayment();
      }
    });
  };

  const getMessageData = React.useCallback(() => {
    FTUserMessage().then((data) => {
      if (data.status) {
        dispatch({ type: "UPDATE_MESSAGE_DATA", payload: data.data });
      } else {
        dispatch({ type: "LOG_OUT" });
      }
    });
  }, [dispatch]);

  const upgradeBtn = () => {
    if (userInfo) {
      if (!isVip) {
        showPayment();
      }
    } else {
      setShowAuthModal("loginCOM");
    }
  };

  const showPayment = () => {
    // if (!window.showPayModel && !window.FotorCommon) {
    //   return;
    // }
    // window.FotorCommon.Analytic.pageView = function(val) {
    //   if (val !== "") {
    //     addpageView(val);
    //   }
    // };
    // window.FotorCommon.User.checkLoginState = function() {
    //   checkIsVip(0);
    //   getMessageData();
    // };
    if (!window.Payment) {
      return;
    }
    !isVip &&
      window.Payment.showPayment &&
      window.Payment.showPayment(() => {
        checkIsVip(0);
      }, 0);
  };

  const loginFunc = (res) => {
    if (res.code === 0 || res.code === 2) {
      dispatch({ type: "LOG_IN", payload: res.userInfo.data });
      checkIsVip(1);
      getMessageData();
    }
    if (res.code === 1) {
      dispatch({ type: "LOG_IN", payload: res.userInfo.data });
      getMessageData();
      setShowAuthModal("loginCOM");
    }
    if (res.code !== 1) {
      setShowAuthModal(null);
    }
  };

  return (
    <>
      <div
        className={classnames(styles.upgrade, isVip ? styles.upgradeHide : "")}
        onClick={upgradeBtn}
      >
        <img
          src={`${process.env.ASSET_PREFIX || ""}/upgrade/Upgrade-${
            siteId ? multipleSiteEnum[siteId] : multipleSiteEnum[1]
          }.png`}
          alt=""
        />
      </div>
      {typeof window !== `undefined` && (
        <FTCommon loginState={loginFunc} modelType={showAuthModal} />
      )}
    </>
  );
};

export default Upgrade;
